<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m6">
      <h5>iRecharge Corporate</h5>
      <p class="text-justify">
        Save money and time by centralizing your business operations with this
        unique corporate solution. Pay for services and recharge all your
        official mobile lines for less in one swift click. This package is best
        suited to companies and multi-nationals because we understand that the
        core of most business operations includes paying bills for airtime,
        internet, power and also making subscription payments for cable TV.
        <br />
        <strong>iRecharge Corporate</strong> provides a value added service to
        such clients and enables them get amazing discounts on major recurrent
        operations cost.
      </p>
      <h5>Benefits</h5>
      <ul>
        <li>
          Get discounts on major recurrent operations cost and still enjoy
          convenience.<em></em>
        </li>
        <li>
          Schedule airtime and data top ups for your staff lines or CUG’s.
        </li>
        <li>Pay your company’s power bills.</li>
        <li>Pay your internet and cable tv subscription.</li>
        <li>Design rewards and promotions for your staff and clients.</li>
        <li>Recharge multiple lines instantly with one click.</li>
        <li>Supports Pre Paid and Post Paid Lines</li>
        <li>
          Can be accessed from any internet enabled computer, tablet or
          smartphone.
        </li>
        <li>Fast and reliable</li>
        <li>Multiple services form one platform</li>
        <li>Secure and verified platform</li>
      </ul>
    </div>
    <solution-part />
  </div>
</template>
<script>
import SolutionPart from '@/components/partials/SolutionPart.vue'
export default {
  name: 'iRechargeCorporate',
  components: {
    SolutionPart
  },
  mounted() {
    this.startCarousel()
  },
  data() {
    return {
      componentKey: false
    }
  },
  methods: {
    startCarousel() {
      var owlClients = $('#owlClients')
      owlClients.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 1000,
        autoplayHoverPause: true
      })
      var owlTestimonial = $('#owlTestimonial')
      owlTestimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
      })
    }
  }
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
